import { render } from "./MaintenanceOSInstanceDetail.vue?vue&type=template&id=fa0c9d76&scoped=true&ts=true"
import script from "./MaintenanceOSInstanceDetail.vue?vue&type=script&lang=ts"
export * from "./MaintenanceOSInstanceDetail.vue?vue&type=script&lang=ts"

import "./MaintenanceOSInstanceDetail.vue?vue&type=style&index=0&id=fa0c9d76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0c9d76"]])

export default __exports__